import { useIsRobinJrApp } from '@/shared/config/useRobinJrApp';
import { AnimationProps } from 'framer-motion';
import { useLocalStorage } from 'hooks/shared';
import { createContext, useEffect, useState } from 'react';
import { SidebarOverlayFixedContextType } from './SidebarOverlayFixedContext.types';

const initialState: SidebarOverlayFixedContextType = {
  isOpen: false,
  setIsOpen: () => {
    throw Error('setIsOpen function must be overridden');
  },
  sidebarRef: null,
  setSidebarRef: () => {
    throw Error('not implemented');
  },
};

export const sidebarAnimationConfig: AnimationProps = {
  initial: { maxWidth: 0.5 },
  animate: { maxWidth: 480 },
  exit: { maxWidth: 0.5 },
  transition: { duration: 0.32, ease: [0.22, 0.9, 0.53, 1] },
};

export const SidebarOverlayFixedContext = createContext(initialState);

export const SidebarOverlayFixedProvider = ({ children }: { children: React.ReactNode }) => {
  const { value: isFirstLogin } = useLocalStorage('first_login');
  const isLandingPage = window.location.pathname.includes('/home');
  const [isOpen, setIsOpen] = useState<boolean>(!isFirstLogin && isLandingPage);
  const [sidebarRef, setSidebarRef] = useState(initialState.sidebarRef);
  const isRobinJrApp = useIsRobinJrApp();

  useEffect(() => {
    if (!window.location.pathname.includes('/search') && !window.location.pathname.includes('/home')) {
      setIsOpen(false);
    }
  }, [window.location.pathname]);

  return (
    <SidebarOverlayFixedContext.Provider
      value={{ isOpen: isRobinJrApp ? false : isOpen, setIsOpen, sidebarRef, setSidebarRef }}>
      {children}
    </SidebarOverlayFixedContext.Provider>
  );
};
